import { FaInstagram, FaTiktok } from "react-icons/fa";
import { Link } from "react-router-dom";

const FooterLanding = () => {
  return (
    <footer className="bg-gray-100 mt-16 py-12 px-6 sm:px-12 text-sm text-gray-700 border-t border-gray-200">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Branding */}
        <div>
          <h4 className="text-lg font-semibold text-gray-900">Vintree</h4>
          <p className="mt-2 text-gray-600 max-w-xs">
            Uma vitrine digital feita para lojas físicas. Conecte desejo à
            conversão com atendimento humano, ágil e organizado.
          </p>
        </div>

        {/* Links úteis */}
        <div>
          <h5 className="text-sm font-semibold uppercase tracking-wide text-gray-800">
            Links úteis
          </h5>
          <ul className="mt-4 space-y-2">
            <li>
              <Link to="/cadastrar" className="hover:underline text-gray-600">
                Criar minha Vintree grátis
              </Link>
            </li>
            <li>
              <Link to="/entrar" className="hover:underline text-gray-600">
                Acessar minha conta
              </Link>
            </li>
            <li>
              <Link to="/termos" className="hover:underline text-gray-600">
                Termos de uso
              </Link>
            </li>
            <li>
              <Link to="/politicas" className="hover:underline text-gray-600">
                Políticas de privacidade
              </Link>
            </li>
          </ul>
        </div>

        {/* Redes sociais */}
        <div>
          <h5 className="text-sm font-semibold uppercase tracking-wide text-gray-800">
            Redes sociais
          </h5>
          <div className="flex gap-4 mt-4">
            <a
              href="https://www.instagram.com/lucaslmir"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-black"
            >
              <FaInstagram className="text-xl" />
            </a>
            <a
              href="https://tiktok.com/@lucas_lmir"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-black"
            >
              <FaTiktok className="text-xl" />
            </a>
          </div>
        </div>
      </div>

      {/* Linha divisória */}
      <hr className="my-6 border-gray-300" />

      {/* Créditos finais */}
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-gray-600">
        <span>© 2025 Vintree. Todos os direitos reservados.</span>
        <span>
          Desenvolvido por <strong>LucasLmir</strong>
        </span>
      </div>
    </footer>
  );
};

export default FooterLanding;
